export default{
    proformaBill: {
        index: 'proforma-bill-index',
    }
}